var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoUbicacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100.001,
    viewBox: "0 0 100 100.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_ubicaci\\xF3n",
    transform: "translate(-2156.822 1039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83",
    "data-name": "Trazado 83",
    d: "M514.581,80.66l-.933.923q-2.284,2.256-4.557,4.522c-.054.054-.108.1-.2.188l-1.21,1.1-.789-1.111c-.062-.088-.118-.172-.171-.255a1.438,1.438,0,0,0-.127-.186q-2.513-2.519-5.035-5.037c-.123-.123-.245-.246-.368-.369l.01.015-1.348.525c-.438.163-.876.319-1.312.474-1,.353-1.936.686-2.83,1.106a9.019,9.019,0,0,0-2.236,1.516,1.559,1.559,0,0,0-.581.968,1.775,1.775,0,0,0,.629,1.107A10.124,10.124,0,0,0,497.37,88.3a32.238,32.238,0,0,0,11.36,1.6,31.263,31.263,0,0,0,9.543-1.492,11.612,11.612,0,0,0,3.817-1.951,2.135,2.135,0,0,0,.95-1.4,2.113,2.113,0,0,0-.95-1.383A14.233,14.233,0,0,0,516.9,81.3Z",
    transform: "translate(1699.511 -1054.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_84",
    "data-name": "Trazado 84",
    d: "M510.055,40.821h-.006a6.9,6.9,0,0,0-4.9,11.754A6.818,6.818,0,0,0,510.02,54.6h.009a6.893,6.893,0,0,0,4.878-11.765,6.815,6.815,0,0,0-4.852-2.013",
    transform: "translate(1697.507 -1046.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85",
    "data-name": "Trazado 85",
    d: "M498.678,0a50,50,0,1,0,50,50,50,50,0,0,0-50-50m11.37,61.483a16.111,16.111,0,0,1,6.817,3.585,5.6,5.6,0,0,1-.026,8.614,15.408,15.408,0,0,1-6.217,3.376,36.8,36.8,0,0,1-11.191,1.581q-.642,0-1.3-.016a34.1,34.1,0,0,1-11.715-2.155,14,14,0,0,1-4.247-2.483A6.45,6.45,0,0,1,479.92,70.3a5.486,5.486,0,0,1,1.493-4.8,13.33,13.33,0,0,1,5.427-3.414,4.785,4.785,0,0,1,2.561-.517q-2.932-2.937-5.858-5.879a20.858,20.858,0,0,1-6.143-12.95c-.822-8.588,2.31-15.516,9.31-20.593A21.2,21.2,0,0,1,501.8,18.282a21.862,21.862,0,0,1,18.91,16.361c1.991,7.963.179,14.971-5.384,20.829-1.907,2.008-3.866,3.995-5.828,5.956a1.683,1.683,0,0,1,.551.056",
    transform: "translate(1708.144 -1039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86",
    "data-name": "Trazado 86",
    d: "M524.519,41.6a17.728,17.728,0,0,0-17.2-13.575,16.872,16.872,0,0,0-3.384.343,17.838,17.838,0,0,0-14.225,16.66,17.111,17.111,0,0,0,4.982,12.982c3.015,3.08,6.122,6.175,9.128,9.168q1.767,1.76,3.533,3.522,1.7-1.7,3.409-3.4c2.944-2.935,5.99-5.969,8.952-8.982a17.308,17.308,0,0,0,4.8-16.719M507.4,56.556h-.01a11.346,11.346,0,0,1,.011-22.691h.007a11.346,11.346,0,1,1-.008,22.691",
    transform: "translate(1700.133 -1044.473)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUbicacion);
export default __webpack_public_path__ + "static/media/ico_ubicacion.62a85b9723c7ed9a3719d55e04efdab6.svg";
export { ForwardRef as ReactComponent };